import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';
import { UploadFileService } from '../services/upload-file.service';

@Component({
  selector: 'app-today-cards-report',
  templateUrl: './today-cards-report.component.html',
  styleUrls: ['./today-cards-report.component.css']
})
export class TodayCardsReportComponent implements OnInit {
  obj : any;
  card_details_todayreport: any [] = [];
  created_date: any;
  constructor(private router: Router, public firebaseService: FirebaseService,private firestore: AngularFirestore,private uploadService: UploadFileService) {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
  };
    this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
      snap.forEach(userRef => {
        if(userRef.data()["role"] !== "admin"){

          var elements= document.getElementById('todaycardreport');
          elements.className = "display-none";
        }else{
          var elements= document.getElementById('todaycardreport');
          elements.className = "display-block";
      var query = this.firestore.collection("users").ref.where("role", "==", "user")
      query.get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if(doc.data()["createddate"].toDate().toLocaleDateString()==new Date().toLocaleDateString()){
            this.card_details_todayreport.push([doc.data()["name"],
            doc.data()["username"],
            doc.data()["phoneno"],
            doc.data()["reference_code"],
            doc.data()["package"],
            doc.data()["createddate"].toDate().toLocaleDateString(),
            doc.data()["enddate"].toDate(),
            doc.data()["approval_status"],
            doc.data()["paid_status"]]);
          }
           });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });






         }
      })
    })
  }
  ngOnInit(): void {
  }

}
